<template>
    <div class="card buildingCard buildingCard-listContainer">
        <div class="card-body buildingCard-body">
            <h5 class="card-title buildingCard-title clearfix">
                 <span class="iconBeforeTitle">
                    <i class="far fa-file-alt"></i>
                 </span>
                Logbook
                <ToolTip>
                    <sup class="superScript">
                        <i class="fas fa-info-circle"
                           data-toggle="tooltip"
                           data-placement="top"
                           data-html="true"
                           title=""
                           data-original-title='Logbook of test results and maintenance records for emergency lights.'
                        ></i>
                    </sup>
                </ToolTip>

                <div class="float-right">
                    <label class="buildingCard-title-checkbox buildingCard-checkbox">
                        <input class="buildingCard-checkbox-input"
                               type="radio"
                               v-bind:value="true"
                               v-on:click="currentFilters.allTestResults = !currentFilters.allTestResults; client.currentPage = 1"
                               v-model="currentFilters.allTestResults"/>
                        <span class="buildingCard-checkbox-container"><i class="fas fa-check buildingCard-checkbox-check" v-bind:class="{'invisible': currentFilters.allTestResults !== true}"></i></span>
                        All test results
                    </label>
                </div>
            </h5>

            <div class="reportList">
                <div class="reportList-title">
                    <div class="reportList-left">
                        Entry
                    </div>
                    <div class="reportList-right">
                        DATE
                    </div>
                </div>

                <template v-if="showInformation">
                    <div v-for="(report, index) in pagedReports" v-bind:key="report.key">
                        <RequiresSitePermissions v-bind:required-permissions="['READ']" v-bind:site-id="buildingId">
                            <div class="reportList-list">
                                <div class="reportList-list-item" v-bind:class="{'reportList-list-item-afss': report.important === true}">
                                    <div class="reportList-left">
                                        <template v-if="report.type === 'reports'">
                                            <RequiresSitePermissions v-if="report.meta.certificate !== undefined" v-bind:required-permissions="['READ']" v-bind:site-id="buildingId">
                                                <a class="reportList-list-sub-item-mainlink" href="javascript:void(0)" v-on:click="requestReport(report.id, 'certificate', getReportName('certificate', report.status, report.meta.certificate.execution_date))">
                                                    <img class="icon icon-pre" v-bind:src="$PUBLIC_PATH + '/icon-pdf.svg'">
                                                    Annual test certificate
                                                </a>
                                            </RequiresSitePermissions>
                                            <template v-else>
                                                <RequiresSitePermissions v-bind:required-permissions="['READ']" v-bind:site-id="buildingId">
                                                    <template v-if="report.meta.repair !== undefined">
                                                        <a class="reportList-list-sub-item-mainlink" href="javascript:void(0)" v-on:click="requestReport(report.id, 'repair', getReportName('repair', report.status))">
                                                            <img class="icon icon-pre" v-bind:src="$PUBLIC_PATH + '/icon-pdf.svg'">
                                                            <template v-if="report.title !== undefined">
                                                                {{report.title}} Test
                                                            </template>
                                                            <template v-else>
                                                                Maintenance Test
                                                            </template>
                                                            <span v-if="report.failed">Failed</span>
                                                            <span v-else>Passed</span>
                                                        </a>
                                                    </template>
                                                </RequiresSitePermissions>
                                                <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                                                    <template v-if="report.meta.repair_detail !== undefined && report.status === 'failed'">
                                                        | <a href="javascript:void(0)" v-on:click="requestReport(report.id, 'repair-detail', getReportName('repair-detail', report.status))">Detailed</a>
                                                    </template>
                                                </RequiresGlobalPermissions>
                                                <RequiresGlobalPermissions v-bind:required-permissions="['DEVELOPER_MODE']">
                                                    <template v-if="report.meta.repair_detail_csv !== undefined && report.status === 'failed'">
                                                        | <a href="javascript:void(0)" v-on:click="requestReport(report.id, 'repair-detail-csv', getReportName('repair-detail-csv', report.status))">CSV</a>
                                                    </template>
                                                </RequiresGlobalPermissions>
                                                <i v-if="!report.failed" class="icon icon-post far fa-check-circle text-success"></i>
                                                <i v-else class="icon icon-post far fa-times-circle text-danger"></i>
                                            </template>
                                        </template>
                                        <template v-else-if="report.type === 'records'">
                                            <RequiresSitePermissions v-bind:required-permissions="['READ']" v-bind:site-id="buildingId">
                                                <template v-if="report.meta.files !== undefined && report.status === 'done'">
                                                    <a href="javascript:void(0)" v-on:click="requestRecord(report.id, 'record', getReportName('record', report.status))">
                                                        <img class="icon icon-pre" v-bind:src="$PUBLIC_PATH + '/icon-pdf.svg'">
                                                        Maintenance Record
                                                    </a>
                                                </template>
                                            </RequiresSitePermissions>
                                        </template>
                                    </div>
                                    <div class="reportList-right">
                                        {{tools.formatDate(new Date(report.sort * 1000))}}
                                    </div>
                                </div>
                            </div>
                        </RequiresSitePermissions>
                    </div>
                </template>
            </div>

            <template v-if="showInformation && client.totalPage > 1">
                <paginate
                        v-model="client.currentPage"
                        :page-count="client.totalPage"
                        :click-handler="pageCallback"
                        :prev-text="'Prev'"
                        :next-text="'Next'"
                        :container-class="'pagination justify-content-center'"
                        :page-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-link-class="'page-link'"
                        :page-link-class="'page-link'">
                </paginate>
            </template>
        </div>
        <InfoComponent v-if="dataToPassToInfoModal.showModal"
                       @close="dataToPassToInfoModal.showModal = false"
                       v-bind:confirm="dataToPassToInfoModal"></InfoComponent>
        <EmbedModalComponent v-if="dataToPassToEmbedModal.showModal"
                             @close="dataToPassToEmbedModal.showModal = false"
                             v-bind:url="dataToPassToEmbedModal.url"
                             v-bind:mime="dataToPassToEmbedModal.mime"></EmbedModalComponent>
    </div>
</template>
<style>
</style>
<script>
import Vue from 'vue'
import RequiresSitePermissions from "@/components/RequiresSitePermissions";
import RequiresGlobalPermissions from "@/components/RequiresGlobalPermissions";
import Tools from '@/app-model/tools.js';
import Report from '@/app-model/report.js';
import EmbedModalComponent from '@/components/modal/EmbedModalComponent.vue';
import InfoComponent from '@/components/modal/InfoComponent.vue';
import ToolTip from '@/components/tool-tip/ToolTip.vue'

let fnData = function() {
    return {
      reports: {
        exists: true,
        list: [],
        page: {
          count_page: 0,
          total_page: 0,
        },
        noFound: false,
        ready: false,
        sort: 'execution_date',
      },
      records: {
        exists: true,
        list: [],
        page: {
          count_page: 0,
          total_page: 0,
        },
        noFound: false,
        ready: false,
        sort: 'maintenance_date',
      },
    };
  }

  export default {
    props: {
      buildingId: Number
    },
    components: {
      RequiresSitePermissions,
      RequiresGlobalPermissions,
      InfoComponent,
      EmbedModalComponent,
      ToolTip
    },
    data() {
      return {
        activeTestId: undefined,
        dataToPassToInfoModal: {
          showModal: false,
          success: false,
          title: '',
          msg: '',
        },
        dataToPassToEmbedModal: {
          showModal: false,
          url: '',
        },
        id: undefined,
        showInformation: false,
        data: fnData(),
        fullList:[],
        client: {
          totalPage: 0,
          currentPage: 1,
          perPage: 5,
        },
        currentFilters: {
          allTestResults: false,
        }
      }
    },
    mounted () {
      this.id = this.buildingId;
      this.fetchAll(this.buildingId);
    },
    computed: {
      tools: function () {
        return new Tools;
      },
      reportModel: function () {
        return new Report;
      },
      isMobile: function () {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      },
      pagedReports: function () {
        let start = (this.client.currentPage - 1) * this.client.perPage,
          end = start + this.client.perPage;

        this.client.totalPage = parseInt(Math.ceil(this.sortedReports.length / this.client.perPage));

        return this.sortedReports.slice(start, end);
      },
      sortedReports() {
        if (!this.showInformation) {
          return [];
        }

        let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'}),
          fullList = JSON.parse(JSON.stringify(this.fullList));

        fullList = fullList.sort((a, b) => {
          return collator.compare(a['sort'], b['sort']) * -1;
        });

        let certificateReports = [];
        for(let i = 0; i < fullList.length; i++) {
          let report = fullList[i];
          if(report.type === 'reports') {
            if(report.meta.certificate !== undefined) {
              let certificateReport = Object.assign({}, report);
              certificateReport.meta = {
                certificate: report.meta.certificate
              };
              certificateReport.important = true;
              certificateReport.sort = certificateReport.meta.certificate.execution_date;
              delete report.meta.certificate;
              certificateReports.push(certificateReport);
            }
          }
        }

        let exportList = [];
        for(let i = 0; i < fullList.length; i++) {
          let report = fullList[i];
          if(report.type === 'reports' && report.base_report_type === 'annual' && report.status === 'passed') {
            let certificateReport = certificateReports.find(el => el.id === report.id);
            certificateReport = certificateReport ? certificateReport : certificateReports.find(el => el.id === report.building_tests_id);
            if(!certificateReport) {
              report.important = true;
            }
            else {
              // need to insert the certificate to front of the passed test, can annual or rerun
              exportList.push(certificateReport);
            }
          }
          if(report.meta !== undefined && Object.keys(report.meta).length > 0) {
            exportList.push(report);
          }
        }

        if (this.currentFilters.allTestResults !== true) {
          exportList = exportList.filter(el => {
            let condition = el.type === 'reports' && (
              (el.building_tests_id !== 0 && el.failed) ||
              el.base_report_type === 'repair' ||
              (el.test_all === 0 && el.building_tests_id === 0)
            );
            return !condition;
          });
        }

        return exportList;
      },
    },
    methods: {
      fetchPagedData (buildingId, requests, var_name) {
        return this.$store.dispatch('apiResult', requests).then(response => {
          if(buildingId === this.id) {
            let assign = this.data[var_name];
            switch (response.status) {
              case 200:
                if(response.data.meta.total === 0 ) {
                  assign.noFound = true;
                  break;
                }

                Object.assign(assign.list, assign.list.concat(response.data.data));

                assign.page.count_page++;

                if(!assign.page.total_page) {
                  assign.page.total_page = response.data.meta.last_page;
                }
                assign.ready = assign.page.count_page === assign.page.total_page;
                break;
              default:
                assign.ready = true;
                break;
            }
            if(Object.keys(this.data).reduce((result, key) => result && (this.data[key].ready || this.data[key].noFound), true)) {
              this.createFullList();
              this.showInformation = true;
            }
          }
          return response;
        });
      },
      async fetchAll (buildingId) {
        this.showInformation = false;
        this.data = Object.assign({}, fnData());
        await Promise.all([
          this.createRequest(buildingId, `api/user-buildings/${buildingId}/reports`, '/api/user-buildings/{building_id}/reports', 1, 'reports'),
          this.createRequest(buildingId, `api/user-buildings/${buildingId}/maintenance-records`, '/api/user-buildings/{building_id}/maintenance-records', 1, 'records')
        ]);
      },
      createRequest(buildingId, path, path_template, page, var_name) {
        return this.fetchPagedData(
          buildingId,
          {
            method: 'GET',
            path: path + `?page=${page}`,
            path_template: path_template,
            building_id: buildingId
          },
          var_name
        ).then(response => {
          page++;
          if (buildingId === this.id) {
            switch (response.status) {
              case 200 :
                for (let i = page; i <= response.data.meta.last_page; i++) {
                  this.fetchPagedData(
                    buildingId,
                    {
                      method: 'GET',
                      path:  path + `?page=${i}`,
                      path_template: path_template,
                      building_id: buildingId
                    },
                    var_name
                  );
                }
                break;
            }
            return response;
          }
        });
      },
      createFullList() {
        let fullList = Object.keys(this.data).reduce((result, key) => {
          for (let i in this.data[key].list) {
            let object = this.data[key].list[i];
            object = Object.assign(object, {
              dataKey: `${key}-${object.id}`,
              type: key,
              sort: object[this.data[key].sort],
              important: false,
            });
            result.push(object);
          }
          return result;
        }, []);
        Vue.set(this, 'fullList', fullList);
      },

      pageCallback(page) {
      },

      getReportName(reportType, status, executionDate = 0) {
        return this.reportModel.getReportName(reportType, status, executionDate);
      },
      requestRecord (id, reportTitle) {
        return this.reportModel.requestRecord(
          {
            store: this.$store,
            infoModal: this.dataToPassToInfoModal,
            embedModal: this.dataToPassToEmbedModal
          },
          this.buildingId,
          id,
          reportTitle
        );
      },
      requestReport (id, reportType, reportTitle) {
        return this.reportModel.requestReport(
          {
            store: this.$store,
            infoModal: this.dataToPassToInfoModal,
            embedModal: this.dataToPassToEmbedModal
          },
          this.buildingId,
          id,
          reportType,
          reportTitle
        );
      },
    }
  }
</script>
<style lang="scss" scoped>
    @import "@/../sass/_building_card.scss";
</style>